module.exports = __webpack_public_path__ + "img/logo-cotizacion.120c35a6.png";